import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import UiIcon from "./UiIcon";
import "./ui.css";

// Same trigger rules as ReusableTextField type="search": typing only edits a
// local draft; the search runs on Enter or when the search icon is clicked.
export default function SearchInput({ state, setState, placeholder, ariaLabel }) {
  const [draft, setDraft] = useState(state);
  useEffect(() => setDraft(state), [state]);

  return (
    <div className="simcc-search">
      <button
        type="button"
        className="simcc-search__submit"
        aria-label="Search"
        onClick={() => setState(draft)}
      >
        <UiIcon name="search" size={14} />
      </button>
      <input
        className="simcc-search__input"
        type="search"
        value={draft}
        placeholder={placeholder}
        aria-label={ariaLabel || placeholder}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && setState(draft)}
      />
    </div>
  );
}

SearchInput.propTypes = {
  state: PropTypes.string,
  setState: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
};

SearchInput.defaultProps = {
  state: "",
  placeholder: "Search…",
  ariaLabel: undefined,
};
